import React, { useState } from 'react';

import narrativLogo from 'images/logos/narrativ_icon_4.png';
import './copy-link.scss';

function CopyLink({ link, reset }) {
	const [copied, setCopied] = useState(false);

	function copy() {
		navigator.clipboard.writeText(link.bam_link_url).then(() => {
			setCopied(true);
		});
	}

	return (
		<div className="copy-link">
			<div className="header">Narrativ Smartlink Creator</div>
			<div className="product-url">{link.bam_link.url}</div>
			<div className="copy-field">
				<div className={`copy-field-inner ${copied ? 'copied' : ''}`}>
					<img src={narrativLogo} alt="Narrativ" />
					<div className="link">{link.bam_link_url}</div>
				</div>
			</div>
			<div className="copy-btn"
				onClick={copy}>
				{copied ? 'Copied!' : 'Copy Link'}
			</div>
			<div className="reset-btn"
				onClick={reset}>
				Create Another Link
			</div>
		</div>
	);
}

export default CopyLink;
